module.exports = __webpack_public_path__ + "static/media/flag-minitour.svg";